import React from 'react';

import PeopleDuoIcon from 'icons/people-duo.svg';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

export default function BlankPersonnelSetSection({ isArchived }) {
  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'personnel.BlankPersonnelSetSection',
  });

  return (
    <div className='section section--notice tw-rounded-t-none tw-border-grey-100 tw-bg-white'>
      <PeopleDuoIcon
        className='[&_path]:tw-fill-grey-500'
        height={64}
        width={64}
      />
      <h2 className='section__header tw-text-l tw-font-semibold tw-text-grey-900'>
        {i18nT(`title.${isArchived ? 'archived' : 'active'}`)}
      </h2>
    </div>
  );
}

BlankPersonnelSetSection.propTypes = {
  isArchived: PropTypes.bool,
};
